/**
 * 회사 정보 상수 — 한 곳에서 관리.
 *
 * 전자상거래법 제13조상 주소·전화번호·통신판매업신고번호는 법적 필수.
 * 아직 확정되지 않은 값은 '{{...}}' 플레이스홀더로 남겨두고 사업자 등록 후 교체.
 */
export const COMPANY = {
  // ── 사업자 정보 ────────────────────────────────────────────
  name: '다산 AI',
  ceo: '이상용',
  brn: '898-05-02943',                    // 사업자등록번호
  tsreg_number: '제2026-3780394-30-2-01412호',  // 통신판매업 신고번호 (성남시 2026-04-25 발급)
  address: '서울 노원구 동일로178길 26, 505호',
  phone: '010-3819-3902',

  // ── 연락처 ─────────────────────────────────────────────────
  email: 'heinrich_dasan@naver.com',            // 대표 이메일
  support_email: 'heinrich_dasan@naver.com',    // 고객 지원 — Naver 로 통합 수신
  privacy_email: 'heinrich_dasan@naver.com',    // 개인정보 문의
  contact_email: 'heinrich_dasan@naver.com',    // 문의
  billing_email: 'heinrich_dasan@naver.com',    // 결제 문의

  // ── 서비스 정보 ────────────────────────────────────────────
  service_name: 'Heinrich',
  service_name_ko: '하인리히',
  domain: 'heinrich.dasancms.co.kr',
  url: 'https://heinrich.dasancms.co.kr',
  established: '2024-03-05',

  // ── 개인정보 보호책임자 (DPO) ─────────────────────────────
  dpo_name: '이상용',                      // 대표자 겸임 (소규모 사업장 관행)
  dpo_email: 'heinrich_dasan@naver.com',
  dpo_phone: '010-3819-3902',

  // ── 법적 문서 시행일 ───────────────────────────────────────
  privacy_effective: '2026년 4월 18일',
  terms_effective: '2026년 4월 18일',
} as const

export type Company = typeof COMPANY
